import { n as __reExport, t as __exportAll } from "./chunk-D1SwGrFN.mjs";
import { t as types_exports } from "./types/index.mjs";
export * from "@proj-airi/plugin-protocol/types";
//#region src/errors.ts
const ServerErrorMessages = {
	invalidEventFormat: "invalid event format",
	invalidToken: "invalid token",
	mustAuthenticateBeforeAnnouncing: "must authenticate before announcing",
	moduleAnnounceIdentityInvalid: "module identity must include kind=plugin and a plugin id for event 'module:announce'",
	moduleAnnounceIndexInvalid: "the field 'index' must be a non-negative integer for event 'module:announce'",
	moduleAnnounceNameInvalid: "the field 'name' must be a non-empty string for event 'module:announce'",
	moduleConsumerEventInvalid: "the field 'event' must be a non-empty string for event consumer registration",
	moduleNotFound: "module not found, it hasn't announced itself or the name is incorrect",
	noConsumerRegistered: "no consumer registered for requested event delivery",
	notAuthenticated: "not authenticated",
	uiConfigureModuleIndexInvalid: "the field 'moduleIndex' must be a non-negative integer for event 'ui:configure'",
	uiConfigureModuleNameInvalid: "the field 'moduleName' can't be empty for event 'ui:configure'"
};
function createInvalidJsonServerErrorMessage(errorMessage) {
	return `invalid JSON, error: ${errorMessage}`;
}
function parseServerErrorMessage(message) {
	if (message === ServerErrorMessages.invalidToken) return {
		authentication: true,
		code: "invalid-token",
		message,
		recoverable: false,
		terminal: true
	};
	if (message === ServerErrorMessages.notAuthenticated) return {
		authentication: true,
		code: "not-authenticated",
		message,
		recoverable: true,
		terminal: false
	};
	if (message === ServerErrorMessages.mustAuthenticateBeforeAnnouncing) return {
		authentication: true,
		code: "must-authenticate-before-announcing",
		message,
		recoverable: true,
		terminal: false
	};
	if (message === ServerErrorMessages.invalidEventFormat) return {
		authentication: false,
		code: "invalid-event-format",
		message,
		recoverable: false,
		terminal: false
	};
	if (message.startsWith("invalid JSON, error: ")) return {
		authentication: false,
		code: "invalid-json",
		message,
		recoverable: false,
		terminal: false
	};
	if (message === ServerErrorMessages.moduleAnnounceNameInvalid) return {
		authentication: false,
		code: "module-announce-name-invalid",
		message,
		recoverable: false,
		terminal: false
	};
	if (message === ServerErrorMessages.moduleAnnounceIndexInvalid) return {
		authentication: false,
		code: "module-announce-index-invalid",
		message,
		recoverable: false,
		terminal: false
	};
	if (message === ServerErrorMessages.moduleAnnounceIdentityInvalid) return {
		authentication: false,
		code: "module-announce-identity-invalid",
		message,
		recoverable: false,
		terminal: false
	};
	if (message === ServerErrorMessages.moduleNotFound) return {
		authentication: false,
		code: "module-not-found",
		message,
		recoverable: false,
		terminal: false
	};
	if (message === ServerErrorMessages.moduleConsumerEventInvalid) return {
		authentication: false,
		code: "module-consumer-event-invalid",
		message,
		recoverable: false,
		terminal: false
	};
	if (message === ServerErrorMessages.noConsumerRegistered) return {
		authentication: false,
		code: "no-consumer-registered",
		message,
		recoverable: true,
		terminal: false
	};
	if (message === ServerErrorMessages.uiConfigureModuleNameInvalid) return {
		authentication: false,
		code: "ui-configure-module-name-invalid",
		message,
		recoverable: false,
		terminal: false
	};
	if (message === ServerErrorMessages.uiConfigureModuleIndexInvalid) return {
		authentication: false,
		code: "ui-configure-module-index-invalid",
		message,
		recoverable: false,
		terminal: false
	};
	return {
		authentication: false,
		code: "unknown",
		message,
		recoverable: false,
		terminal: false
	};
}
function isAuthenticationServerErrorMessage(message) {
	return parseServerErrorMessage(message).authentication;
}
function isTerminalAuthenticationServerErrorMessage(message) {
	const parsed = parseServerErrorMessage(message);
	return parsed.authentication && parsed.terminal;
}
__reExport(/* @__PURE__ */ __exportAll({
	ServerErrorMessages: () => ServerErrorMessages,
	createInvalidJsonServerErrorMessage: () => createInvalidJsonServerErrorMessage,
	isAuthenticationServerErrorMessage: () => isAuthenticationServerErrorMessage,
	isTerminalAuthenticationServerErrorMessage: () => isTerminalAuthenticationServerErrorMessage,
	parseServerErrorMessage: () => parseServerErrorMessage
}), types_exports);
//#endregion
export { ServerErrorMessages, createInvalidJsonServerErrorMessage, isAuthenticationServerErrorMessage, isTerminalAuthenticationServerErrorMessage, parseServerErrorMessage };

//# sourceMappingURL=index.mjs.map